import { ColumnDef } from "@tanstack/react-table";
import { dayjs } from "@/core/utils/date";
import type { IcmJob } from "@/icm/types";

const JobCompletedOnCol: ColumnDef<IcmJob, unknown> = {
  accessorKey: "job_completed_on",
  header: "Completed",
  meta: { size: "140px" },
  cell: ({ getValue }) => {
    const value = getValue() as string | null;
    return value ? dayjs(value).format("MMM DD, YYYY") : "-";
  },
};

export default JobCompletedOnCol;
